const AUTH_ACTION_TYPES = {
  HANDLE_LOGIN: 'HANDLE_LOGIN',
  HANDLE_LOGOUT: 'HANDLE_LOGOUT',
  HANDLE_REGISTER: 'HANDLE_REGISTER',
  HANDLE_AUTH_RESET: 'HANDLE_AUTH_RESET',
  HANDLE_USER_INFORMATION: 'HANDLE_USER_INFORMATION',
}

export default AUTH_ACTION_TYPES
